import React from 'react';
import {
  Card,
} from 'antd';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
  Title
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
  ChartDataLabels,
  Title
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: 'top',
    },
    title: {
      display: true,
      text: 'ยอดขายประจำสัปดาห์',
    },
  },
  maintainAspectRatio: false,

};

function DashboardBarchart({ barData }) {

  const data = {
    labels: barData.labels,
    datasets: [
      {
        type: 'line',
        label: 'Dataset 1',
        borderColor: 'rgb(255, 99, 132)',
        borderWidth: 2,
        fill: false,
        data: barData.acc_total,
        datalabels: {
          anchor: 'top',
          align: 'top',
          offset: 0,
          formatter: function (value, context) {
            value = value.toString();
            value = value.split(/(?=(?:...)*$)/);
            value = value.join(',');
            return value;

          }
        }
      },
      {
        type: 'bar',
        label: 'Dataset 2',
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
        data: barData.daily_total,
        borderColor: 'white',
        borderWidth: 2,
        datalabels: {
          labels: {
            title: null
          }
        },
      },
    ],
  };

  return (
    <Card
      bordered={false}
      bodyStyle={{
        border: '1px solid #f2f2f2',
        borderRadius: "8px",
        minHeight: '350px'
      }}
    >
      <Chart type='bar' data={data} options={options} plugins={[ChartDataLabels]} />
    </Card>
  )
}

export default DashboardBarchart